import { ApiSendEmailRequest } from '../interfaces';

export function mapSendEmailRequest(mailQuestionId: number): ApiSendEmailRequest {
    return {
        mail_question: {
            mail_question_id: mailQuestionId,
        },
    };
}
